// @flow

import React from 'react';
import { SK_ADNETWORK_DATASOURCE } from '../../../common/support/eo_mapping/datasources';
import InFilter from '../../../common/support/utils/druid/filters/InFilter';
import { generateTransformerFromEventDescription } from '../../components/DruidSummaryTiles/utils';

// --------------------------------------- GENERAL --------------------------------------- //
export const INIT_DEFAULT_RANGE = 7;

export const DOWNLOADS_DIMENSION = SK_ADNETWORK_DATASOURCE;
export const REDOWNLOAD_DIMENSION = 'body_redownload';
export const CONVERSION_VALUE_DIMENSION = 'body_conversion_value';
export const MAPPED_CONVERSION_VALUE =
  'annotation_conversion_value_mapped_value';
export const AD_NETWORK_NAME_DIMENSION = 'annotation_dollar_3p';
export const SOURCE_APP_ID_DIMENSION = 'body_source_app_id';
export const CAMPAIGN_ID_DIMENSION = 'body_campaign_id';

export const REINSTALLS = 'installs';
export const INSTALLS = 'reinstalls';
export const V1_INSTALLS = 'v1 installs';

export const REDOWNLOAD_VALUES = {
  NULL: null,
  INSTALL: 'false',
  REINSTALL: 'true'
};

export const ALL_CONVERSION_VALUES: string[] = Array.from(
  new Array(64),
  (x, i) => String(i)
);

export const INSTALLS_EVENT = {
  dataSource: SK_ADNETWORK_DATASOURCE,
  filter: new InFilter(REDOWNLOAD_DIMENSION, [REDOWNLOAD_VALUES.INSTALL])
};
export const INSTALLS_EVENT_KEY = JSON.stringify(INSTALLS_EVENT);

export const REINSTALLS_EVENT = {
  dataSource: SK_ADNETWORK_DATASOURCE,
  filter: new InFilter(REDOWNLOAD_DIMENSION, [REDOWNLOAD_VALUES.REINSTALL])
};
export const REINSTALLS_EVENT_KEY = JSON.stringify(REINSTALLS_EVENT);

export const V1_INSTALLS_EVENT = {
  dataSource: SK_ADNETWORK_DATASOURCE,
  filter: new InFilter(REDOWNLOAD_DIMENSION, [REDOWNLOAD_VALUES.NULL])
};

export const V1_INSTALLS_EVENT_KEY = JSON.stringify(V1_INSTALLS_EVENT);

export const CONVERSION_VALUE_EVENTS = {
  dataSource: SK_ADNETWORK_DATASOURCE,
  filter: new InFilter(CONVERSION_VALUE_DIMENSION, ALL_CONVERSION_VALUES)
};

export const CONVERSION_VALUE_EVENTS_KEY = JSON.stringify(
  CONVERSION_VALUE_EVENTS
);

export const NON_CONVERSION_VALUE_EVENTS = {
  dataSource: SK_ADNETWORK_DATASOURCE,
  filter: new InFilter(CONVERSION_VALUE_DIMENSION, [null])
};

export const NON_CONVERSION_VALUE_EVENTS_KEY = JSON.stringify(
  NON_CONVERSION_VALUE_EVENTS
);

// ---------------------------------------- REPORT TABS ---------------------------------------- //
export const INIT_REPORT_TYPE = 'ad_networks';

export const REPORT_TAB_CONFIG = [
  {
    key: 'ad_networks',
    title: 'Ad Networks',
    component: <div />,
    hide: false,
    beta: false
  },
  {
    key: 'campaigns',
    title: 'Campaigns',
    component: <div />,
    hide: false,
    beta: false
  },
  {
    key: 'source_apps',
    title: 'Source Apps',
    component: <div />,
    hide: false,
    beta: false
  },
  {
    key: 'conversion_events',
    title: 'Conversion Events',
    component: <div />,
    hide: false,
    beta: false
  },
  {
    key: 'downloads',
    title: 'Downloads',
    component: <div />,
    hide: false,
    beta: false
  },
  {
    key: 'custom',
    title: 'Custom Report',
    component: <div />,
    hide: false,
    beta: false
  }
];

// ---------------------------------------- SUMMARY TILES ---------------------------------------- //
export const TILE_CONFIG = [
  {
    title: 'INSTALLS',
    key: 'installs',
    transformer: generateTransformerFromEventDescription(INSTALLS_EVENT)
  },
  {
    title: 'REINSTALLS',
    key: 'reinstalls',
    transformer: generateTransformerFromEventDescription(REINSTALLS_EVENT)
  },
  {
    title: 'CONVERSION EVENTS',
    key: 'conversion_events',
    transformer: generateTransformerFromEventDescription(
      CONVERSION_VALUE_EVENTS
    )
  }
];

export const TILE_DATASOURCES = [SK_ADNETWORK_DATASOURCE];

// ------------------------------------------ TIMESERIES ------------------------------------------ //

export const TIMESERIES_COMPAREBY_DIMENSIONS = [
  AD_NETWORK_NAME_DIMENSION,
  CAMPAIGN_ID_DIMENSION,
  SOURCE_APP_ID_DIMENSION,
  REDOWNLOAD_DIMENSION,
  CONVERSION_VALUE_DIMENSION,
  MAPPED_CONVERSION_VALUE
];

export const DEFAULT_TIMESERIES_CONFIGURATION = {
  events: [DOWNLOADS_DIMENSION],
  compareByDimensions: [AD_NETWORK_NAME_DIMENSION]
};

export const reportTypeTimeseriesMapping = {
  ad_networks: {
    events: [DOWNLOADS_DIMENSION],
    compareByDimensions: [AD_NETWORK_NAME_DIMENSION]
  },
  campaigns: {
    events: [DOWNLOADS_DIMENSION],
    compareByDimensions: [AD_NETWORK_NAME_DIMENSION, CAMPAIGN_ID_DIMENSION]
  },
  source_apps: {
    events: [DOWNLOADS_DIMENSION],
    compareByDimensions: [SOURCE_APP_ID_DIMENSION]
  },
  downloads: {
    events: [DOWNLOADS_DIMENSION],
    compareByDimensions: [REDOWNLOAD_DIMENSION]
  },
  conversion_events: {
    events: [DOWNLOADS_DIMENSION],
    compareByDimensions: [CONVERSION_VALUE_DIMENSION]
  },
  custom: {
    events: [DOWNLOADS_DIMENSION],
    compareByDimensions: [AD_NETWORK_NAME_DIMENSION]
  }
};

// -------------------------------------------- TABLE -------------------------------------------- //
export const DEFAULT_TABLE_COLUMNS = [
  DOWNLOADS_DIMENSION,
  INSTALLS_EVENT_KEY,
  REINSTALLS_EVENT_KEY,
  CONVERSION_VALUE_EVENTS_KEY
];

export const DOWNLOADS_COLUMN = {
  display: 'downloads',
  key: SK_ADNETWORK_DATASOURCE,
  type: 'formula',
  popover: '' // TODO: add popover
};

export const INSTALLS_COLUMN = {
  display: INSTALLS,
  key: INSTALLS_EVENT_KEY,
  type: 'formula',
  popover: '' // TODO: add popover
};

export const REINSTALLS_COLUMN = {
  display: REINSTALLS,
  key: REINSTALLS_EVENT_KEY,
  type: 'formula',
  popover: '' // TODO: add popover
};

export const CONVERSION_EVENTS_COLUMN = {
  display: 'total conversion events',
  key: CONVERSION_VALUE_EVENTS_KEY,
  type: 'formula',
  popover: '' // TODO: add popover
};

export const V1_INSTALLS_COLUMN = {
  display: V1_INSTALLS,
  key: V1_INSTALLS_EVENT_KEY,
  type: 'formula',
  popover: '' // TODO: add popover
};

export const NON_CONVERSION_EVENTS_COLUMN = {
  display: 'non-conversion events',
  key: NON_CONVERSION_VALUE_EVENTS_KEY,
  type: 'formula',
  popover: '' // TODO: add popover
};

const STANDARD_COLUMNS = [
  DOWNLOADS_COLUMN,
  INSTALLS_COLUMN,
  REINSTALLS_COLUMN,
  CONVERSION_EVENTS_COLUMN
];

export const TABLE_COMPAREBY_DIMENSIONS = [
  AD_NETWORK_NAME_DIMENSION,
  CAMPAIGN_ID_DIMENSION,
  SOURCE_APP_ID_DIMENSION,
  REDOWNLOAD_DIMENSION,
  CONVERSION_VALUE_DIMENSION,
  MAPPED_CONVERSION_VALUE
];

export const DEFAULT_TABLE_CONFIGURATION = {
  selectedColumns: DEFAULT_TABLE_COLUMNS,
  compareByDimensions: [AD_NETWORK_NAME_DIMENSION]
};

export const reportTypeTableMapping = {
  ad_networks: {
    selectedColumns: STANDARD_COLUMNS,
    compareByDimensions: [AD_NETWORK_NAME_DIMENSION]
  },
  campaigns: {
    selectedColumns: STANDARD_COLUMNS,
    compareByDimensions: [AD_NETWORK_NAME_DIMENSION, CAMPAIGN_ID_DIMENSION]
  },
  source_apps: {
    selectedColumns: STANDARD_COLUMNS,
    compareByDimensions: [SOURCE_APP_ID_DIMENSION]
  },
  downloads: {
    selectedColumns: [
      INSTALLS_COLUMN,
      REINSTALLS_COLUMN,
      V1_INSTALLS_COLUMN,
      CONVERSION_EVENTS_COLUMN
    ],
    compareByDimensions: [REDOWNLOAD_DIMENSION]
  },
  conversion_events: {
    selectedColumns: STANDARD_COLUMNS,
    compareByDimensions: [CONVERSION_VALUE_DIMENSION]
  },
  custom: {
    selectedColumns: STANDARD_COLUMNS,
    compareByDimensions: [AD_NETWORK_NAME_DIMENSION]
  }
};

export const REDOWNLOAD_DIMENSION_MAPPING = {
  true: REINSTALLS,
  false: INSTALLS,
  null: V1_INSTALLS
};
